<template>
  <div class="el-chunk eu-no-padding">
    <emd-form-group
      :label="$t('invite.create.role')"
      :required="true"
      class="eu-no-padding"
    >
      <div class="eu-mt_5">
        <div
          v-for="(role, index) in roles"
          :key="index"
          class="eu-mb_5"
        >
          <emd-radio
            class="eu-mb_2 _bold"
            name="radio-role-user"
            :label="role.value"
            :id="`role-type-${role.key}`"
            :value="role.key"
            v-model="permission"
            :data-testid="`input-role-type-${role.key.toLowerCase()}`"
            size="small"
          />
          <emd-text
            v-if="role.description"
            size="small"
            tag="p"
            variation-color="subtle"
            class="eu-ml_5"
            >{{ role.description }}</emd-text
          >
        </div>
      </div>
    </emd-form-group>

    <emd-text
      tag="p"
      size="small"
      class="emd-text _color_subtle"
    >
      <em
        class="emd-text _size_small eu-mr_2 _color_success uil uil-info-circle"
      ></em
      >{{ $t('role-help-info') }}
      <a
        href="https://pagarme.helpjuice.com/p2-manual-da-dashboard/configura%C3%A7%C3%B5es-usu%C3%A1rios"
        target="_blank"
        class="emd-text _color_success"
        rel="noopener noreferrer"
        >{{ $t('about-more') }}</a
      >
    </emd-text>
  </div>
</template>
<script>
import { EmdRadio, EmdFormGroup, EmdText } from 'emerald-vue/src/components'
import { mapGetters } from 'vuex'

export default {
  name: 'RoleFormGroup',
  components: {
    EmdText,
    EmdRadio,
    EmdFormGroup
  },
  props: {
    userRole: {
      required: true
    }
  },
  data () {
    return {
      permission: null
    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  watch: {
    permission: function (value) {
      this.$emit('update:model-value', value)
    }
  },
  created () {
    this.permission = this.userRole
  }
}
</script>
<style scoped>
._bold {
  font-weight: bold;
}
</style>

<i18n>
{
    "pt-BR": {
      "role-help-info": "Explore as diferenças entre os perfis de acesso em nossa FAQ.",
      "about-more": "Saiba mais."
    },
    "en-US": {
      "role-help-info": "Explore the differences between access profiles in our FAQ.",
      "about-more": "Learn more."
    }
}
</i18n>
